import { useEffect, useState } from "react";

//Hook to solved client rendering and hydrated issues
export const useHasMounted = () => {

  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);

  return hasMounted;
};
